import React from 'react';
import { SwiperComponent } from 'vitl-component-library';
// styles
import styles from './vitamin-cards-carousel.module.scss';

interface IProps {
  title: string;
  benefits?: Array<{
    filename_disk: string;
    text: string;
  }>;
  vitamins: Array<{
    name: string;
    measurement: string;
    filename_disk: string;
    points: Array<{
      point: string;
    }>;
    benefit_effects: Array<{
      effect_icon: any;
      effect_title: any;
    }>;
  }>;
  background?: string;
}

const VitaminCardsCarousel: React.FC<IProps> = ({ benefits, title, vitamins, background = '' }) => {
  return (
    <section className={styles['section' + background]}>
      <div className={styles.container}>
        <h2>{title}</h2>

        {benefits && benefits?.length > 0 && (
          <div className={styles.benefitIconsWrapper}>
            {benefits.map((benefit: any) => {
              const { filename_disk, text } = benefit;

              return (
                <div className={styles.benefitIconsItem}>
                  <img src={`${process.env.GATSBY_MEDIA_URL}${filename_disk}`} width="26" />
                  {text}
                </div>
              );
            })}
          </div>
        )}

        <SwiperComponent
          paginationType="bullets"
          breakpoints={{
            768: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            992: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            1280: {
              slidesPerView: 4,
              spaceBetween: 20,
            },
          }}
        >
          {vitamins.map(vitamin => {
            const { name, filename_disk, points, measurement, benefit_effects } = vitamin;
            return (
              <div className={styles.vitaminCard}>
                <span
                  style={{
                    backgroundImage: `url('${process.env.GATSBY_MEDIA_URL}${filename_disk}')`,
                    width: '100%',
                    height: '60px',
                    display: 'block',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center center',
                  }}
                ></span>
                <div className={styles.vitaminCardContent}>
                  <h4>{name}</h4>
                  <small>{measurement}</small>
                  <ul>
                    {points &&
                      points.length > 0 &&
                      points.map(x => (
                        <li>
                          <span>{x.point}</span>
                        </li>
                      ))}
                  </ul>
                  {benefit_effects && (
                    <div className={styles.vitaminEffectsList}>
                      {benefit_effects.length > 0 &&
                        benefit_effects.map(effect => (
                          <div className={styles.vitaminEffectsListItem}>
                            <img src={`${process.env.GATSBY_MEDIA_URL}${effect.effect_icon}`} width="22" />
                            <p>{effect.effect_title}</p>
                          </div>
                        ))}
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </SwiperComponent>
      </div>
    </section>
  );
};

export default VitaminCardsCarousel;
